import React, { useEffect, useRef } from "react";
import { createChart } from "lightweight-charts";
import { areaOptions, chartOptions } from "../data";
import { getData } from "../helpers";
import ChartOverlay from "utils/ChartOverlay";

const MarketUpdateAreaChart = ({ loading, stocks, mode }) => {
	const chartContainerRef = useRef();
	const chart = useRef();
	const series = useRef();

	useEffect(() => {
		chart.current = createChart(
			chartContainerRef.current,
			chartOptions(mode)
		);
		series.current = chart.current.addAreaSeries(areaOptions);
		series.current.setData(getData(stocks) || []);
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (stocks) {
			const stockData = getData(stocks);
			series.current.setData([...stockData]);
			stocks?.length < 100 && chart.current.timeScale().fitContent();
		}
		// eslint-disable-next-line
	}, [stocks]);

	return (
		<div ref={chartContainerRef} className="chart__wrap">
			<ChartOverlay loading={loading} data={stocks} />
		</div>
	);
};

export default MarketUpdateAreaChart;
